import Button from "../../Custom/Button/Button";
import "./notificationBar.css";
import picture0 from "../../picture/14.png";
import picture1 from "../../picture/15.png";
import star from "../../picture/zvezda.png";
import sendIcon from "../../picture/send.png";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import send from "../../picture/send.png";
import { compareAsc } from "date-fns";
import CustomSlider from "./CustomSlider";
import CustomList from "./CustomList";
import { useRef } from "react";

const NotificationBar = ({
  setAddNotification,
  currentActive,
  setCurrentActive,
  currentNotification,
  setCurrentNotification,
  handleSetNotifications,
  isFromSliderRef,
  setNotificationsList,
  isEditing,
  setIsEditing,
  currentSelectedNotification,
  notifications,
  notificationsList,
  setNotifications,
  selectedCompany,
}) => {
  const textAreaRef = useRef();

  const handleChangeName = (e) => {
    setCurrentNotification({ ...currentNotification, name: e.target.value });
  };

  const handleActive = (position) => {
    if (position === currentActive) {
      setCurrentActive(0);
    } else {
      setCurrentActive(position);
    }
  };

  const handleCloseNotification = () => {
    setAddNotification(false);
    setCurrentNotification({
      name: "",
      location: "",
      user: "",
      startTime: "",
      endTime: "",
      date: "",
      description: "Ova notifikacija je obavezna",
      comment: [],
      notifyUsers: [],
      alarms: [],
      alarmTime: "",
    });
    setCurrentActive(0);
    setNotificationsList([]);
    isFromSliderRef.current = false;
    setIsEditing(false);
  };

  const handleSelectNotification = () => {
    if (!isEditing) return true;
    let isEdit = false;
    if (currentSelectedNotification.name !== currentNotification.name) {
      isEdit = true;
    }

    if (
      compareAsc(currentSelectedNotification.date, currentNotification.date) !==
      0
    ) {
      isEdit = true;
    }

    if (
      currentSelectedNotification.startTime !== currentNotification.startTime
    ) {
      isEdit = true;
    }

    if (currentSelectedNotification.endTime !== currentNotification.endTime) {
      isEdit = true;
    }

    if (
      currentSelectedNotification.description !==
      currentNotification.description
    ) {
      isEdit = true;
    }
    if (
      currentSelectedNotification.alarms.length !==
      currentNotification.alarms.length
    ) {
      isEdit = true;
    } else {
      currentSelectedNotification.alarms.map((alarm, index) => {
        if (compareAsc(alarm, currentNotification.alarms[index]) !== 0) {
          isEdit = true;
        }
      });
    }

    let foundUser;
    currentSelectedNotification.notifyUsers.map((user) => {
      foundUser = currentNotification.notifyUsers.find(
        (notifyUser) =>
          notifyUser.id === user.id && notifyUser.forNotify !== user.forNotify
      );

      if (foundUser) isEdit = true;
    });
    console.log(foundUser);
    console.log(currentSelectedNotification);
    console.log(currentNotification);

    if (currentSelectedNotification.location !== currentNotification.location)
      isEdit = true;
    return isEdit;
  };

  const handleAddDescription = () => {
    if (textAreaRef.current.value === "") return;
    if (isEditing) {
      setCurrentNotification({
        ...currentNotification,
        description: textAreaRef.current.value,
      });
    } else {
      setNotificationsList(
        notificationsList.map((notification) => {
          return { ...notification, description: textAreaRef.current.value };
        })
      );
    }
    setCurrentActive(0);
  };

  return (
    <div className="wraper-notification-bar">
      <div className="notification-bar-name">
        <input
          value={currentNotification.name || ""}
          onChange={handleChangeName}
        ></input>
        <div
          className="notification-bar-cancel"
          onClick={() => handleCloseNotification()}
        >
          <Button>X</Button>
        </div>
      </div>
      <div className="notification-bar-central">
        <div
          className="notification-bar-button"
          onClick={() => {
            handleActive(1);
          }}
        >
          <Button
            active={currentActive === 1}
            isDisabled={currentNotification.name === ""}
          >
            <div className="notification-button-icon-img">
              <AccessTimeIcon />
              {currentNotification.startTime === "" &&
                currentNotification.endTime === "" && (
                  <div className="notification-button-star">
                    <img src={star} alt="" />
                  </div>
                )}
            </div>
          </Button>
        </div>
        <div
          className="notification-bar-button"
          onClick={() => {
            handleActive(2);
          }}
        >
          <Button
            active={currentActive === 2}
            isDisabled={
              currentNotification.name === "" ||
              (currentNotification.startTime === "" &&
                currentNotification.endTime === "")
            }
          >
            <div className="notification-button-icon">
              <div className="notification-button-icon-img">
                <NotificationsIcon />
                {currentNotification.startTime === "" &&
                  currentNotification.endTime === "" && (
                    <div className="notification-button-alarm-star">
                      <img src={star} alt="" />
                    </div>
                  )}
              </div>
              <div className="notification-button-icon-img">
                <HourglassBottomIcon />
              </div>
            </div>
          </Button>
        </div>
        <div
          className="notification-bar-button"
          onClick={() => {
            handleActive(3);
          }}
        >
          <Button
            active={currentActive === 3}
            isDisabled={
              currentNotification.name === "" ||
              (currentNotification.startTime === "" &&
                currentNotification.endTime === "")
            }
          >
            <div className="notification-button-icon">
              <div className="notification-plus">+</div>
              <div className="notification-button-icon-img">
                <img src={picture0} alt="" />
              </div>
            </div>
          </Button>
        </div>
        <div
          className="notification-bar-button"
          onClick={() => {
            handleActive(4);
          }}
        >
          <Button
            active={currentActive === 4}
            isDisabled={
              currentNotification.name === "" ||
              (currentNotification.startTime === "" &&
                currentNotification.endTime === "")
            }
          >
            <div className="notification-button-icon">
              <div className="notification-plus">+</div>
              <div className="notification-button-icon-img">
                <img src={picture1} alt="" />
              </div>
            </div>
          </Button>
        </div>
      </div>
      <div className="notification-bar-menu">
        <div
          className="notification-bar-button"
          onClick={() => {
            handleActive(5);
          }}
        >
          <Button
            active={currentActive === 5}
            isDisabled={currentNotification.name === ""}
          >
            <div className="notification-button-icon">
              <div className="notification-button-icon-img">
                <BorderColorIcon />
              </div>
              <div className="notification-button-icon-img">
                <AccessTimeIcon />
              </div>
            </div>
          </Button>
        </div>
        <div
          className="notification-bar-button button-central"
          onClick={() => {
            handleActive(6);
          }}
        >
          <Button
            active={currentActive === 6}
            isDisabled={currentNotification.name === ""}
          >
            <div className="notification-bar-button-text">DESCRIPTION</div>
          </Button>
        </div>
        <div
          className="notification-bar-button"
          onClick={handleSetNotifications}
        >
          {handleSelectNotification() ? (
            <Button
              activation={true}
              image={send}
              isDisabled={currentNotification.name === ""}
            ></Button>
          ) : (
            <Button
              activation={true}
              isDisabled={currentNotification.name === ""}
            >
              RESET
            </Button>
          )}
        </div>
      </div>
      <div className="notification-bar-content">
        {/*currentActive === 0 && (
          <NotificationList
            currentActive={currentActive}
            setCurrentNotification={setCurrentNotification}
            currentNotification={currentNotification}
            setIsEditing={setIsEditing}
            isEditing={isEditing}
            setAddNotification={setAddNotification}
            notifications={notifications}
            setNotificationsList={setNotificationsList}
            setCurrentSelectedNotification={setCurrentSelectedNotification}
          />
        )*/}
        {currentActive === 1 && (
          <CustomSlider
            currentActive={currentActive}
            setCurrentActive={setCurrentActive}
            currentNotification={currentNotification}
            setCurrentNotification={setCurrentNotification}
            notificationsList={notificationsList}
            setNotificationsList={setNotificationsList}
            isFromSliderRef={isFromSliderRef}
            setNotifications={setNotifications}
            notifications={notifications}
            setIsEditing={setIsEditing}
            isEditing={isEditing}
          />
        )}
        {currentActive === 2 && (
          <CustomSlider
            currentActive={currentActive}
            setCurrentActive={setCurrentActive}
            currentNotification={currentNotification}
            setCurrentNotification={setCurrentNotification}
            notificationsList={notificationsList}
            setNotificationsList={setNotificationsList}
            isFromSliderRef={isFromSliderRef}
            notifications={notifications}
            setNotifications={setNotifications}
            setIsEditing={setIsEditing}
            isEditing={isEditing}
          />
        )}
        {currentActive === 3 && (
          <CustomList
            currentActive={currentActive}
            notificationsList={notificationsList}
            setNotificationsList={setNotificationsList}
            setCurrentActive={setCurrentActive}
            currentNotifaction={currentNotification}
            isEditing={isEditing}
            setCurrentNotification={setCurrentNotification}
            selectedCompany={selectedCompany}
          />
        )}
        {currentActive === 4 && (
          <CustomList
            currentActive={currentActive}
            notificationsList={notificationsList}
            setNotificationsList={setNotificationsList}
            setCurrentActive={setCurrentActive}
            currentNotifaction={currentNotification}
            isEditing={isEditing}
            setCurrentNotification={setCurrentNotification}
            selectedCompany={selectedCompany}
          />
        )}
        {currentActive === 5 && (
          <CustomSlider
            currentActive={currentActive}
            setCurrentActive={setCurrentActive}
            currentNotification={currentNotification}
            setCurrentNotification={setCurrentNotification}
            notificationsList={notificationsList}
            setNotificationsList={setNotificationsList}
            isFromSliderRef={isFromSliderRef}
            notifications={notifications}
            setNotifications={setNotifications}
            setIsEditing={setIsEditing}
            isEditing={isEditing}
          />
        )}
        {currentActive === 6 && (
          <div className="description">
            <textarea
              defaultValue={currentNotification.description || ""}
              rows={8}
              ref={textAreaRef}
            />
            <div className="description-add" onClick={handleAddDescription}>
              <Button activation={true} image={sendIcon}></Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationBar;
